<template>
  <div id="user-activity-table-container">
    <div class="user-activity-header-container">
      <div class="grid-column ai-c jc-s gap-16">
        <SACSelect
          :value="selectedEventCode"
          :options="typeOptions"
          :change="v => changeState('selectedEventCode', v)"
          containerClass="ct-select-container"
        />
        <DateRangeFilter />
      </div>
    </div>
    <div class="user-activity-container">
      <v-data-table
        :headers="headers"
        :items="userActivityTableData"
        :loading="loading"
        :options="uaTableOptions"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        height="700px"
        fixed-header
        hide-default-footer
        :custom-sort="customSort"
      >
        <template #[`item.logDate`]="{ item }">
          <td>
            <span>{{ customDateFilterMoment(item.logDate, dateFormat) }}</span>
          </td>
        </template>
        <template #[`item.category`]="{ item }">
          <td>
            <span> {{ item.category || item.alertCategory }}</span>
          </td>
        </template>
        <template #[`item.customerName`]="{ item }">
          <td>
            <router-link :to="`/member/${item.customerId}`">
              {{ item.customerName }}
            </router-link>
          </td>
        </template>
      </v-data-table>
    </div>
    <SACTableFooter
      :totalRecords="uaTableOptions.totalItems"
      :rowCount="uaTableOptions.itemsPerPage"
      :page="uaTableOptions.page"
      :changeRowCount="changeRowCount"
      :changePage="changePage"
      :totalPage="userActivityTableRecordCount"
      :loading="loading"
    />
  </div>
</template>

<script>
import SACTableFooter from '@shared/components/table/SACTableFooter.vue';
import userActivitiesMixin from '@shared/mixins/userActivitiesMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import DateRangeFilter from '@shared/components/userActivities/DateRangeFilter.vue';
import SACSelect from '../sac/SACSelect.vue';

export default {
  name: 'UserActivitiesTable',
  components: {
    DateRangeFilter,
    SACTableFooter,
    SACSelect,
  },
  mixins: [userActivitiesMixin, unitPreferencesMixin],
  data() {
    return {
      sortBy: 'timestamp',
      sortDesc: true,
      headers: [{
        text: 'Timestamp',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'logDate',
        width: '10%',
      },
      {
        text: 'Name',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'customerName',
        width: '10%',
      },
      {
        text: 'UID',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'uid',
        width: '10%',
      },
      {
        text: 'Description',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'description',
        width: '10%',
      }, {
        text: 'Category/Alert Category',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'category',
        width: '10%',
      }, {
        text: 'Alert Type',
        align: 'start',
        filterable: true,
        sortable: true,
        value: 'alertType',
        width: '10%',
      }],
    };
  },
  methods: {
    customSort(items, index, isDesc) {
      this.$store.dispatch('uaChangeTableOption', {
        field: 'sortBy',
        value: index,
      });

      this.$store.dispatch('uaChangeTableOption', {
        field: 'sortDesc',
        value: isDesc,
      });

      items.sort((a, b) => {
        if (index[0] === 'customerName') {
          if (!a.customerName) {
            return 1;
          }
          if (!b.customerName) {
            return -1;
          }
          if (!isDesc[0]) {
            return a.customerName.toLowerCase() < b.customerName.toLowerCase() ? -1 : 1;
          }
          return b.customerName.toLowerCase() < a.customerName.toLowerCase() ? -1 : 1;
        }
        if (index[0] === 'description') {
          if (!a.description) {
            return 1;
          }
          if (!b.description) {
            return -1;
          }
          if (!isDesc[0]) {
            return a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1;
          }
          return b.description.toLowerCase() < a.description.toLowerCase() ? -1 : 1;
        }
        if (index[0] === 'category') {
          if (!a.category && !a.alertCategory) {
            return 1;
          }
          if (!b.category && !b.alertCategory) {
            return -1;
          }
          const categoryA = a.category ? a.category : a.alertCategory;
          const categoryB = b.category ? b.category : b.alertCategory;
          if (!isDesc[0]) {
            return categoryA.toLowerCase() < categoryB.toLowerCase() ? -1 : 1;
          }
          return categoryB.toLowerCase() < categoryA.toLowerCase() ? -1 : 1;
        }
        if (index[0] === 'alertType') {
          if (!a.alertType) {
            return 1;
          }
          if (!b.alertType) {
            return -1;
          }
          if (!isDesc[0]) {
            return a.alertType.toLowerCase() < b.alertType.toLowerCase() ? -1 : 1;
          }
          return b.alertType.toLowerCase() < a.alertType.toLowerCase() ? -1 : 1;
        }
        if (index[0] === 'logDate') {
          if (!a.logDate) {
            return 1;
          }
          if (!b.logDate) {
            return -1;
          }
          const dateA = new Date(a.logDate);
          const dateB = new Date(b.logDate);

          if (!isDesc[0]) {
            return dateA < dateB ? -1 : 1;
          }
          return dateB < dateA ? -1 : 1;
        }
        return 0;
      });

      return items;
    },
    changeSearch(value) {
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'userActivityTableSearch',
        value,
      });
    },
    changeState(field, value) {
      this.changeUserActivityValues([{
        field,
        value,
      }]);
      this.$store.dispatch('getUserActivities');
    },
    changeTableOption(rowCount) {
      this.$store.dispatch('uaChangeTableOption', {
        field: 'itemsPerPage',
        value: rowCount,
      });
    },
    changePage(page) {
      this.$store.dispatch('uaChangeTableOption', {
        field: 'page',
        value: page,
      });
      const get = async () => {
        this.$store.dispatch('getUserActivities');
      };
      get();
    },
  },
};
</script>

<style lang="scss">

#user-activity-table-container {
  width: 100%;
  max-width: 1705px;
  .user-activity-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
  }
  .user-activity-container {
    background-color: $WHITE;
    box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
    border-radius: 6px;
    padding-bottom: 12px;
    .v-data-table__wrapper {
      height: 700px;
      thead {
        tr {
          th {
            background-color: $N100;
            text-transform: uppercase;
            color: $WHITE;
            font-size: 15px;
            font-weight: 500;
            .mdi-checkbox-blank-outline::before,
            .mdi-checkbox-marked::before,
            .mdi-minus-box::before,
            .mdi-arrow-up::before {
              color: $WHITE;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            border-bottom: 0;
          }
          &:hover {
            background: none;
          }
          &:nth-child(even) {
            background-color: $NBLUE5;
          }
        }
      }
    }
  }
}
</style>
